import { render, staticRenderFns } from "./MarkPaper.vue?vue&type=template&id=66ee2e77&scoped=true"
import script from "./MarkPaper.vue?vue&type=script&lang=js"
export * from "./MarkPaper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ee2e77",
  null
  
)

export default component.exports